const myOrganizationsSearchResultsActions = {
  SET_MY_ORGANIZATIONS_INIT_STATE: 'SET_MY_ORGANIZATIONS_INIT_STATE',
  GET_MY_ORGANIZATIONS: 'GET_MY_ORGANIZATIONS'
};
export default myOrganizationsSearchResultsActions;
